<template>
    <div>
        <v-dialog persistent v-model="dialog" max-width="700">
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">پایگاه دانش</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-6 mt-5">
                    <v-text-field
                        :loading="searchLoading"
                        @keyup.enter="search"
                        v-model="searchText"
                        hide-details
                        variant="solo"
                        prepend-inner-icon="search"
                        label="جستجو ..."
                        bg-color="#f4f4f4"
                        class="w-100 mb-3 rounded-lg"
                    >
                        <template #append-inner>
                            <v-btn v-if="!searchLoading && searchText" @click="search" icon="keyboard_arrow_left" variant="text"></v-btn>
                        </template>
                    </v-text-field>
                </div>
                <div class="px-3 me-1 ms-2 mt-0 text-grey-darken-2 position-relative" style="min-height: 350px;max-height: 400px;overflow-y: auto;scrollbar-width: thin; border-bottom: 8px solid white">
                    <v-row align="center" class="mx-0 rounded my-2" justify="space-between" style="background-color: #f8f8f8" v-for="(item, index) in articlesList" :key="index">
                        <v-col>
                            <p class="mb-0 text-grey-darken-2 text-meta user-select-none cursor-pointer d-inline-block">{{ item.name }}</p>
                            <div class="rounded-pill py-0 text-small text-white bg-grey-darken-1 px-2 ms-2 d-inline-block user-select-none" v-if="item.user_group == 'employees'">کاربران سازمانی</div>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn @click="$emit('paste', item.url)" class="ms-2" color="secondary" variant="tonal" v-tooltip="'لینک مقاله'" width="33" height="33" size="x-small" icon="icon-copy"></v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            searchLoading: false,
            searchText: null,
            articlesList: [],
        }
    },
    methods: {
        search(){
            this.searchLoading = true;
            this.$kbArticleList({s:this.searchText}).then(res => {
                if(res && res.status == "OK")
                    this.articlesList = res.data.map(x => {return {...x, url: `<a dir="ltr" rel="nofollow" href="${window.location.origin}/kb/articles/${x.id}/${x.slug}" target="_blank">${window.location.origin}/kb/articles/${x.id}/${x.slug}</a>`}});
            }).finally(()=>{this.searchLoading = false;})
        },
    },
    watch: {
        dialog(){
            if(!this.dialog){
                this.searchText = null;
                this.articlesList = [];
                this.searchLoading = false
            }
        }
    },
}
</script>
